import type { ProjectCopyMap } from './types';

export const ko: ProjectCopyMap = {
  kura: {
    tagline: '개인용 에이전트 OS — 로컬 데몬 하나에 여러 개의 얇은 클라이언트.',
    summary:
      'Rust 컨트롤 플레인이 로컬에서 실행되며 런타임, LLM 프로바이더, 채널 커넥터, 저장소, 이벤트를 담당합니다. 클라이언트는 얇게 유지됩니다: React 웹 UI, 전체 화면 Rust TUI, 채팅 채널 커넥터, TypeScript SDK — 모두 동일한 JSON Schema 계약을 따릅니다.',
    body: [
      '제품의 본체는 데몬입니다. 정확해야 하는 모든 것 — 세션 상태, 프로바이더 라우팅, 툴 하네스, 이벤트 로그 — 이 하나의 Rust 워크스페이스에 모여 로컬 HTTP API 뒤에 있습니다. 클라이언트는 그 위의 뷰일 뿐입니다. 데몬 바이너리는 `dope-cli`, HTTP API는 `dope-api`입니다.',
      '언어 간 계약은 `schemas/`에 JSON Schema로 존재하며 API, 이벤트, 설정의 유일한 기준입니다. Rust 데몬과 TypeScript 클라이언트는 관례로 맞추는 대신 같은 정의에서 생성됩니다.',
      '명시된 전제는 오래 사는 에이전트 상태가 관측 가능하고 재생 가능하며 안전하게 진화할 수 있어야 한다는 것입니다. 컨텍스트 엔지니어링, 메모리, 계획, 인계, 정책은 임시방편이 아니라 재설계 대상입니다.',
    ],
    highlights: [
      'Rust 컨트롤 플레인: 런타임, LLM 프로바이더, 채널/커넥터, 스토어, 이벤트, HTTP API, 하네스를 하나의 워크스페이스에 통합.',
      '하나의 데몬 위에 세 가지 인터페이스: React 19 + Vite 웹 UI, 전체 화면 Rust TUI(`dope-tui`), 채팅 채널 커넥터.',
      '공유 JSON Schema 계약에서 생성되는 TypeScript 클라이언트 SDK(`@dope/client`).',
      '테스트와 프로덕션 환경 분리 — `~/.dope-test`는 19192 포트, `~/.dope`는 19191 포트. 테스트에서는 실제 커넥터가 기본 비활성화.',
      '이전 Go 데몬은 Rust 워크스페이스로 완전히 대체되었으며 마이그레이션 기록은 `crates/MIGRATION.md`에 있습니다.',
    ],
  },

  gozen: {
    tagline: 'API 프록시 자동 페일오버를 갖춘 멀티 CLI 환경 전환기.',
    summary:
      'Claude Code, Codex, OpenCode의 환경을 한곳에서 전환하고, 상위 프로바이더가 불안정해져도 작업을 계속합니다 — GoZen이 API 트래픽을 프록시하고 자동으로 페일오버합니다.',
    body: [
      '모든 API 설정은 `~/.zen/zen.json`에 모이고, 단일 `zend` 데몬이 프록시 서버와 비밀번호로 보호되는 웹 UI를 함께 호스팅합니다. 디렉터리를 특정 프로파일과 CLI에 바인딩할 수 있어, 프로젝트 폴더에서 `zen`만 입력하면 알맞은 클라이언트가 알맞은 프로바이더로 연결됩니다.',
      '도입할 이유는 프록시에 있습니다. 요청은 thinking, image, long-context 같은 특성에 따라 라우팅되고, 주 프로바이더를 쓸 수 없으면 백업으로 넘어갑니다. 3버전에서는 프로바이더·모델·프로젝트별 토큰/비용 추적, 경고·다운그레이드·차단 동작이 있는 예산 한도, 프로바이더 헬스 체크, 여러 부하 분산 전략, 웹훅 알림이 추가되었습니다.',
      '설정은 WebDAV, S3, GitHub Gist 또는 GitHub 저장소를 통해 기기 간 동기화할 수 있으며 AES-256-GCM으로 암호화됩니다. 웹 UI 토큰은 세션 인증 하에 RSA로 암호화되어 전송됩니다.',
    ],
    highlights: [
      'Claude Code, Codex, OpenCode를 하나의 전환기로 관리하며 디렉터리 바인딩으로 프로젝트별 설정 가능.',
      '백업 프로바이더로 자동 페일오버하는 내장 HTTP 프록시와 시나리오 라우팅(thinking, image, 긴 컨텍스트).',
      '프로바이더·모델·프로젝트별 사용량 및 비용 추적, 일/주/월 예산 한도.',
      '지연 시간과 오류율을 추적하는 프로바이더 헬스 모니터링. 페일오버, 라운드로빈, 최소 지연, 최소 비용 분산.',
      'WebDAV, S3, GitHub Gist, GitHub 저장소를 통한 암호화 설정 동기화(AES-256-GCM).',
      'Telegram, Discord, Slack, Lark, Messenger에서 Claude Code 세션을 모니터링하고 제어하는 봇 게이트웨이.',
      '`zen upgrade`로 자체 업데이트하며 zsh / bash / fish 자동완성 제공.',
    ],
    commandLabels: ['설치', '첫 실행'],
  },

  loopforge: {
    tagline: '데스크톱 워크벤치를 갖춘 독립형 로컬 게임 개발 에이전트.',
    summary:
      'Loopforge는 평범한 게임 저장소 안에서 동작합니다. 아이디어를 플레이 가능한 실험으로 바꾸고, 기술적 증거와 사람의 증거를 모아, 유지할지 접을지 다시 만들지를 분명하게 결정하도록 돕습니다. 에이전트가 제어의 중심이고 데스크톱 Workbench가 사용 창구이며, CLI와 Skills는 손으로 다루는 대상이 아니라 내부 실행 수단입니다.',
    body: [
      '프로젝트를 여는 것이 준비의 전부입니다. Workbench가 네이티브 폴더 선택으로 게임 저장소를 받아 해당 프로젝트의 에이전트를 시작하거나 다시 연결하고, 제한된 프로젝트 컨텍스트를 불러옵니다. 이 과정에서 프로바이더 자격 증명, 환경 변수, 액세스 토큰은 노출되지 않습니다.',
      '인터페이스는 에이전트 프로세스가 아니라 프로젝트를 축으로 구성됩니다. 프로젝트 메뉴가 저장소와 프로젝트 단위 화면을 전환하고, 헤더가 프로젝트 정체성과 필요한 동작을 담으며, 작업 영역에는 모드별 도구가 놓이고, 떠 있는 모드 툴바가 탐색·디자인·빌드·테스트 사이를 오갑니다. 채팅은 작업을 대체하지 않고 그 옆에 있습니다. 프로젝트 상태와 증거가 게임 저장소에 남기 때문에, 무슨 일이 있었는지에 대한 기록이 채팅 로그 하나에 달려 있지 않습니다.',
      '경계는 의도적으로 그어져 있습니다. `apps/agent`는 도메인 에이전트와 사용자에게 보이는 동작을, `cli`는 결정론적 프로젝트 작업과 헤드리스 어댑터를 담당하되 제어의 중심은 분명히 아닙니다. `skills`는 판단이 필요한 작업을 위한 버전화된 능력이고, `contracts`는 버전화된 스키마입니다. Kura는 범용 모델·세션·런타임 동작을 제공하며 Loopforge 상태는 전혀 갖지 않고, 릴리스 앱은 에이전트와 고정된 Kura 사이드카를 함께 담습니다.',
    ],
    highlights: [
      '데스크톱 Workbench(Tauri + React)가 제품의 본체이며, 관리하는 사이드카는 에이전트뿐입니다.',
      '프로젝트는 평범한 게임 저장소에서 열리고, 불러오는 컨텍스트에는 자격 증명과 환경 변수가 포함되지 않습니다.',
      '탐색·디자인·빌드·테스트를 오가는 모드 툴바, 그리고 작업을 대체하지 않고 옆에 있는 에이전트 채팅.',
      '상태와 증거가 저장소에 기록되므로 무슨 일이 있었는지가 채팅 로그에 의존하지 않습니다.',
      '결정론적 작업과 버전화된 Skills는 자동화와 진단을 위해 남아 있습니다. 내부 능력이지 진입점이 아닙니다.',
      '범용 모델·세션·런타임은 고정된 Kura 사이드카가 제공하고, 도메인 로직은 Loopforge 쪽에 남습니다.',
    ],
    commandLabels: ['체크아웃에서 Workbench 실행'],
    requirements:
      'Git, Node.js 22와 pnpm, Rust와 Cargo, Python 3.11+와 uv. Godot 4는 Godot 워크플로를 쓸 때만 필요합니다. 아직 패키징된 릴리스가 없어 데스크톱 앱은 체크아웃에서 빌드합니다.',
  },

  pingo: {
    tagline: '처음부터 새로 설계한 웹 Canvas 렌더링 엔진.',
    summary:
      '고성능 TSX 런타임과 결정론적 Rust/WASM 코어, 네이티브 가상 스크롤과 Canvas 네이티브 텍스트 편집, 그리고 SCSS/Less 빌드 타임 파이프라인을 갖춘 버전 지정 CSS 서브셋. shadcn에 맞춘 UI 컴포넌트 라이브러리(약 50개)를 제공하며, 공식 사이트의 컴포넌트 문서는 모두 엔진이 Canvas에서 실시간으로 렌더링합니다.',
    body: [
      'Pingo는 마일스톤 로드맵의 초기 단계를 지났습니다. 편집·이벤트·히트 테스트·접근성 체인이 이미 갖춰져 있고, 텍스트·이미지·도형 같은 기본 요소, 네이티브 가상 스크롤, IME를 지원하는 Canvas 네이티브 텍스트 편집 등 실제로 쓸 수 있는 프리미티브를 제공합니다. 기술 결정은 여전히 `docs/design.md`를 따릅니다.',
      '스타일링은 캐스케이드 의미가 예측 가능한 버전 지정 CSS 서브셋이며, SCSS/Less 빌드 타임 파이프라인으로 기존 스타일시트를 그대로 옮길 수 있습니다. 그 위에는 shadcn에 맞춘 약 50개의 UI 컴포넌트 — 버튼, 폼, 오버레이, 데이터 표시 — 가 있고, 모두 DOM이 아니라 Canvas에 렌더링됩니다.',
      '공식 사이트 자체가 증거입니다. 모든 컴포넌트 문서에 엔진이 실시간으로 렌더링하는 라이브 데모가 내장되어 브라우저에서 바로 조작할 수 있습니다. 문서에서 보이는 것이 곧 Pingo 위에서 실행 중인 것입니다.',
    ],
    highlights: [
      '가상 스크롤을 애드온이 아닌 일급 프리미티브로 갖춘 고성능 TSX 런타임.',
      '버전이 지정된 바이너리 ABI 뒤의 결정론적 Rust/WASM 코어.',
      'Canvas 네이티브 텍스트 편집: EditContext 우선 입력, 중앙화된 textarea 프록시 폴백, 결정론적 IME 기록/재생.',
      '플랫폼 인증은 마일스톤 완료와 명확히 분리되어 있으며, 인증되지 않은 플랫폼에서는 성능을 주장하지 않습니다.',
    ],
    commandLabels: ['저장소 체크아웃에서 프로브 실행'],
    requirements: 'Node.js 22.12+, pnpm 10.33.2, Rust 1.96.0(wasm32-unknown-unknown 타깃 포함).',
  },

  deckle: {
    tagline: 'AI가 생성한 대량의 웹 산출물을 위한 무한 캔버스.',
    summary:
      '수백 개의 살아 있는 iframe은 확장되지 않고, 모든 페이지를 이미지로 평탄화하면 선택과 이벤트 타기팅을 잃습니다. Deckle은 산출물을 보존된 형태로 유지합니다 — 소스, 지속 상태, 상호작용 트리, 페인트 캐시, 선택적 라이브 런타임 — 그래서 Figma 같은 선택과 활성화가 살아남습니다. 백엔드에 독립적인 엔진 계약은 구현되고 테스트되었지만, 브라우저 증거 게이트는 아직 통과하지 못했습니다.',
    body: [
      '모든 iframe은 브라우징 컨텍스트, DOM/CSS 상태, 스크립트 realm, 리소스, 렌더링 상태를 유지하므로 생성된 페이지 수백 개를 살려 두는 비용이 큽니다. 설계적 답은 보존형 산출물 모델 — `산출물 = 소스 + 지속 상태 + 상호작용 트리 + 페인트 캐시 + 선택적 라이브 런타임` — 이며 스냅샷은 페인트 캐시일 뿐입니다. 문서와 상호작용 모델은 계속 남아 선택, 이벤트 라우팅, 활성화, 리비전 안전한 복원에 쓰입니다.',
      '산출물은 에이전트에서 오기 때문에 조금씩 도착합니다. 그래서 스트리밍은 노드 모델을 감싸는 층이 아니라 모델 자체의 일급 속성입니다. 콘텐츠 종류마다 자기 경계에서 커밋하며 — 자소, 한 줄, 닫힌 마크다운 구조, JSON 값, 확정된 HTML 태그 — 그 경계는 앞으로만 이동합니다. 독자가 해석이 철회되는 것을 보는 일은 없습니다.',
      '오늘 구현되고 테스트된 것: 씬 트랜잭션, 카메라와 공간 가상화, 생명주기와 예산, 산출물 리비전, 새니타이즈, 통제된 런타임 프로토콜, 보존형 렌더링, 내부 히트 테스트. 아직 아닌 것: M0 브라우저 증거 게이트는 통과하지 않았고, 실험적 HTML-in-Canvas API 지원은 프로브가 감지하는 "능력"이지 약속이 아니며, 절대 성능·메모리 기준은 측정값이 나올 때까지 설정하지 않습니다. 아직 안정적인 공개 계약은 하나도 없습니다.',
      '이름 자체가 주장입니다. deckle은 수제 종이에서 펄프가 가라앉기 전 종이를 둘러싸는 틀이고, 그 틀이 남기는 거친 가장자리를 deckle edge라고 부릅니다. 아직 다 도착하지 않은 콘텐츠에 틀을 두르고 그 경계를 감추는 대신 드러내는 것 — 이 엔진이 하는 일이 바로 그것입니다.',
    ],
    highlights: [
      '보존형 산출물 모델: 스냅샷은 페인트 캐시일 뿐이므로 선택과 이벤트 타기팅이 유지됩니다.',
      '스트리밍이 노드 모델에 내장되어 있고, 종류별 커밋 경계는 앞으로만 이동합니다 — 철회되는 해석이 없습니다.',
      '구현·테스트된 엔진 계약: 씬 트랜잭션, 카메라와 공간 가상화, 생명주기, 예산, 리비전, 새니타이즈, 런타임 프로토콜, 보존형 렌더링, 히트 테스트.',
      '보안은 나중의 강화 작업이 아니라 일급 패키지입니다 — 새니타이저, URL 정책, 쿼터, 케이퍼빌리티.',
      'Apache-2.0을 택한 이유는 특허 허여입니다. 스트리밍 경계 모델과 캔버스 네이티브 렌더링 프로파일은 명시적 허여가 의미 있는 구현 영역입니다.',
      '라이브러리는 0.3.0까지 `@dopejs/canvas-*`로 배포되었고 0.4.0부터 `@dopejs/deckle-*`로 이름이 바뀝니다. 바뀌는 것은 이름뿐입니다.',
    ],
    requirements: 'Node.js 22.12+ 및 pnpm 10.33.2.',
  },
};
